<template>
  <div class="fieldset">
    <h3 class="fieldset-heading">Funeral Specifics</h3>

    <FuneralType v-model="form.data.funeral.details.typeOption" />
    <StyleType v-model="form.data.funeral.details.styleOptions" @input="setStyleOptions" />

  </div>
</template>

<script>
import { willPeopleHelpers} from "@/components/common/questionnaires/fieldsets/will/helpers/willPeopleHelpers";
import { fieldsetHelpers } from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import { willFuneralHelpers } from "@/components/common/questionnaires/fieldsets/will/helpers/willFuneralHelpers";
import {clone} from "@/mixins/clone";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";

import FuneralType from "@/components/common/questionnaires/question/questions/will/funeral/FuneralType";
import StyleType from "@/components/common/questionnaires/question/questions/will/funeral/StyleType";

export default {
  name: 'FuneralTypeService',
  mixins: [
    fieldsetHelpers,
    willPeopleHelpers,
    clone,
    saveHelpers,
    willFuneralHelpers
  ],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    StyleType,
    FuneralType
  },
  data() {
    return {
      label: 'Service', // used for steps progress
      primaryOptions: [],
      secondaryOptions: [],
      backupOptions: [],
      db: {
        saveLocation: 'product_will_data',
        saveField: 'details',
        formPath: 'data.funeral.details'
      }
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  }
};
</script>
